import { pick } from 'lodash/fp';

import config from '@config';

import { FILE_KEY } from '../constants';
import createDataSource from '../createDataSource';
import { getDefaultEmptyList, getDefaultListHandler } from '../utils';

import { PATHS } from './constants';

const MEDIA_PATHNAME = 'media';

export default () => {
  const dataSource = createDataSource(config.api.url);

  const upload = (file, type) => {
    const formData = new FormData();
    formData.append(FILE_KEY, file);

    return dataSource.post(PATHS[type], { body: formData }).json();
  };

  const create = async ({ file, ...values }) => {
    const fileName = await upload(file, values.type);

    return dataSource.post(MEDIA_PATHNAME, { json: { ...values, fileName } }).json();
  };

  const update = async ({ file, id, ...values }) => {
    let { fileName } = values;
    if (file) {
      fileName = await upload(file, values.type);
    }

    return dataSource.put(`${MEDIA_PATHNAME}`, { json: { ...values, fileName, id } }).json();
  };

  const upsert = (json) => (json.id ? update(json) : create(json));

  const getById = ({ id }) => dataSource.get(`${MEDIA_PATHNAME}/${id}`).json();

  return {
    getList: getDefaultListHandler({
      url: MEDIA_PATHNAME,
      dataSource,
      transformFilter: pick(['tag', 'type']),
    }),

    getById,

    create,

    update,

    upsert,

    getEmptyList: getDefaultEmptyList,
  };
};
